import React from 'react';
import { GenericListPage } from '../../components/generic';
import { ActivityLog } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useActivityLogs } from './useData';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const List: React.FC = () => {
  const { colors } = useTheme();
  const useData = (searchParams?: string) => {
    // Parse search params to filters
    const params = new URLSearchParams(searchParams);
    const filters: any = {};
    
    if (params.get('userId')) filters.userId = parseInt(params.get('userId')!, 10);
    if (params.get('entityType')) filters.entityType = params.get('entityType')!;
    if (params.get('entityId')) filters.entityId = parseInt(params.get('entityId')!, 10);
    if (params.get('action')) filters.action = params.get('action')!;
    if (params.get('startDate')) filters.startDate = params.get('startDate')!;
    if (params.get('endDate')) filters.endDate = params.get('endDate')!;
    if (params.get('ipAddress')) filters.ipAddress = params.get('ipAddress')!;

    return useActivityLogs(Object.keys(filters).length > 0 ? filters : undefined);
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* GenericListPage */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<ActivityLog>
          useData={useData}
          config={{
            ...moduleConfig,
            getColumns,
            getToolbarIcon,
            getTableActions,
          }}
        />
      </div>
    </div>
  );
};

export default List;
